import {OnInit, Provider} from '@angular/core';
import {ProjectConstants} from './project-constants';
import {UserModel} from '../models/UserModel';
import { Offset } from 'src/models/Offset';
import {ProviderModel} from '../models/ProviderModel';
export class BaseGeneralComponent extends ProjectConstants implements OnInit {

  user: UserModel;
  showFilter: boolean;
  filterContainer: any;

  canSelect: boolean;
  canInsert: boolean;
  canUpdate: boolean;
  canDelete: boolean;
  canExecute: boolean;

  public static isNumAnnoMeseInFilterList(numAnnoMeseSelected: number, numAnnoMeseFilterList: Array<number>): boolean {
    if (!numAnnoMeseSelected || !numAnnoMeseFilterList) {
      return false;
    }

    for (let _i = 0; _i < numAnnoMeseFilterList.length; _i++) {
      if (numAnnoMeseSelected === numAnnoMeseFilterList[_i]) {
        return true;
      }
    }

    return false;
  }

  constructor() {
    super();
  }

  setUserGrants(grantList: Array<string>) {
    if (!grantList || grantList.length === 0) {
      return;
    }

    for (let _i = 0; _i < grantList.length; _i++) {
      if (this.GRANTS.ALL === grantList[_i]) {
        this.canDelete = true;
        this.canExecute = true;
        this.canInsert = true;
        this.canSelect = true;
        this.canUpdate = true;
        return;
      } else if (this.GRANTS.SELECT === grantList[_i]) {
        this.canSelect = true;
      } else if (this.GRANTS.UPDATE === grantList[_i]) {
        this.canUpdate = true;
      } else if (this.GRANTS.DELETE === grantList[_i]) {
        this.canDelete = true;
      } else if (this.GRANTS.INSERT === grantList[_i]) {
        this.canInsert = true;
      } else if (this.GRANTS.EXECUTE === grantList[_i]) {
        this.canExecute = true;
      }
    }
  }

  ngOnInit() {
  }

  checkRole() {
    if (this.user.roleList[0].toLowerCase() === this.ROLE.GESTORE_LC.toLowerCase()) {
      return true;
    }
    return false;
  }

  getAnnoMese(annoMese: number ): string {
    const year = Number(annoMese.toString().substring(0, 4));
    const month = Number(annoMese.toString().substring(4, 6));

    const options = { month: 'long', year: 'numeric' };
    const parsedYearMonth = new Date(year, month - 1);

    return parsedYearMonth.toLocaleDateString('en-US', options);
  }

  getQuarter(quarter: number): string {
    const qt = 'Q' + Number(quarter.toString().substring(4, 5));
    const year = Number(quarter.toString().substring(0, 4));

    return qt + ' ' + year;
  }

  toCustomString(element: any): string {
    if (element !== null && element !== '') {
      return element.toString();
    }
    return 'N.D.';
  }

  toCustomStringAnnoMese(element: any): string {
    if (element) {
      return this.getAnnoMese(element);
    }
    return 'N.D.';
  }

  toCustomStringIs(element: any): string {
    if (!element) {
      return 'NO';
    }
    return 'YES';
  }


  toCustomStringNumberPerc(element: any): string {
    if (element !== null) {
      return element.toString()  + '%';
    }
    return 'N.D.';
  }

  KeyPressNumber($event: KeyboardEvent, element?: HTMLInputElement) {
    return $event.code !== 'KeyE';

  }

  setOffsetInSession(newOffset: Offset, offsetType: string) {
    if (newOffset) {
      sessionStorage.setItem(offsetType, JSON.stringify(newOffset));
    } else {
      const sessionOffset = sessionStorage.getItem(offsetType);
      newOffset = sessionOffset !== 'undefined' && sessionOffset !== null ? JSON.parse(sessionOffset) : new Offset(10, 0);
    }

    return newOffset;
  }


    filterFromDxc(providerDefault: ProviderModel, resultYearMonth: Array<number>) {
      const resultFiltered = [];
      if (providerDefault.description === this.PROVIDER_DXC) {
        resultYearMonth.forEach(
          function(item) {
            const itemStr = item.toString();
            if (!(itemStr.substring(0, 4) === '2019')) {
              resultFiltered.push(item);
            }
          }
        );

        return resultFiltered;
      }
      return resultYearMonth;
    }

    intermittentFilterButton(intermittent: boolean) {
      const buttonFilter = document.getElementsByClassName('filter-button') as HTMLCollectionOf<HTMLElement>;
      if (intermittent) {
        buttonFilter[0].setAttribute("style", "animation: glowing 1500ms infinite; color: white;");
        // @ts-ignore
        buttonFilter[0].firstChild.setAttribute('src', this.ICONS.FILTER_WHITE);
      } else {
        buttonFilter[0].removeAttribute('animation: glowing 1500ms infinite;');
        buttonFilter[0].setAttribute('style', 'color: #7a93e1;');
        // @ts-ignore
        buttonFilter[0].firstChild.setAttribute('src', this.ICONS.FILTER_BLUE);
      }
    }

}


